import React from "react";

export default function ChartIcon() {
  return (
    <svg
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.84875 3.60387C2.75 4.66479 2.75 6.37458 2.75 9.79175V19.4584C2.75 22.8756 2.75 24.5854 3.84875 25.6463C4.94625 26.7084 6.715 26.7084 10.25 26.7084H20.25C23.785 26.7084 25.5538 26.7084 26.6513 25.6463C27.75 24.5854 27.75 22.8756 27.75 19.4584V9.79175C27.75 6.37458 27.75 4.66479 26.6513 3.60387C25.5538 2.54175 23.785 2.54175 20.25 2.54175H10.25C6.715 2.54175 4.94625 2.54175 3.84875 3.60387ZM22.54 11.6707C22.724 11.4041 22.7909 11.0777 22.7259 10.7634C22.661 10.4491 22.4696 10.1726 22.1938 9.99475C21.9179 9.81689 21.5803 9.75223 21.2552 9.815C20.93 9.87777 20.644 10.0628 20.46 10.3295L16.655 15.8479L16.0813 14.7387C15.2225 13.0796 12.83 12.9346 11.765 14.4789L7.96 19.9961C7.77601 20.2628 7.70912 20.5891 7.77405 20.9034C7.83899 21.2177 8.03043 21.4942 8.30625 21.6721C8.58208 21.8499 8.91969 21.9146 9.24484 21.8518C9.56998 21.7891 9.85601 21.604 10.04 21.3374L13.845 15.8201L14.4187 16.9282C15.2775 18.5884 17.67 18.7322 18.735 17.188L22.54 11.6707Z"
        fill="#065B70"
      />
    </svg>
  );
}
